<template>
    <VListItemSubtitle v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot />
    </VListItemSubtitle>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-list-item-subtitle';

export default {
    name: 'SrListItemSubtitle',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
